import { environment } from 'src/environments/environment';

export const API_BASE_URL = environment.apis.default.url.replace(/\/$/, '');

export const API_PREFIX = '/api/agentic-cx';

export function resolveUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}